import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoadingService } from '../services/loading.service';

/**
 * Increments the LoadingService counter for the duration of each studio-API
 * request so the shell's global progress bar reflects real data loads. Only
 * studio-API calls are tracked (matched on `/wgagentsstudio/`) so background
 * asset / third-party requests don't flicker the bar. `finalize` guarantees
 * the counter is released on success, error, or unsubscribe.
 *
 * Streaming poll GETs are excluded: the co-builder / test-chat stream is polled
 * every 500-700ms (`.../<something>-stream/<stream_id>`), which pulsed the
 * global bar continuously for the whole turn. The streamed turn has its own
 * live-typing indicator, so those polls carry no progress-bar value — only the
 * initial POST (URL ends in `-stream`, no trailing id) is tracked.
 */
const STREAM_POLL = /-stream\/[^/]+$/;

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loading: LoadingService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.includes('/wgagentsstudio/') || STREAM_POLL.test(req.url)) {
      return next.handle(req);
    }
    this.loading.start();
    return next.handle(req).pipe(finalize(() => this.loading.stop()));
  }
}
